module.exports = __webpack_public_path__ + "img/xWhite.8e23e663.gif";